import { render, staticRenderFns } from "./CustomerOverviewMobile.vue?vue&type=template&id=47a5426e&scoped=true&"
import script from "./CustomerOverviewMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerOverviewMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOverviewMobile.vue?vue&type=style&index=0&id=47a5426e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5426e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a5426e')) {
      api.createRecord('47a5426e', component.options)
    } else {
      api.reload('47a5426e', component.options)
    }
    module.hot.accept("./CustomerOverviewMobile.vue?vue&type=template&id=47a5426e&scoped=true&", function () {
      api.rerender('47a5426e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages-mobile/Customers/CustomerOverviewMobile.vue"
export default component.exports